<script>
import {projectState} from '@app/store/projectStore.svelte.js';
import {
    showModal
} from '@app/store/modalStore.svelte.js';
import {
    historyState
} from '@app/store/historyStore.svelte.js';

import firebase from '@app/configs/firebase.js';
import * as m from '@app/paraglide/messages.js';
let userId = firebase.auth().currentUser.uid;
</script>

{#if projectState.ownerId === userId}
<li class="nav-item" role="menuitem">
    <a class="nav-link" href="#!/" onclick={() => showModal("snapshotHistory")} id="historyBtn" aria-label={m.team_menu_project_history()}>
        <i class="bi bi-clock-history" aria-hidden="true"></i>
    </a>
</li>
<li class="nav-item" role="menuitem">
    <a class="nav-link" href="#!/" onclick={() => showModal("teamShare")} id="shareBtn" aria-label={m.team_menu_share_project()}>
        <i class="bi bi-folder-symlink" aria-hidden="true"></i>
    </a>
</li>
{/if}
<li class="nav-item" role="menuitem" title={m.team_menu_sync_changes()}> 
    <a class="nav-link {historyState.actions.length > 1 ? 'text-warning' : ''}" href="#!/" 
       onclick={() => showModal("teamSync")} 
       id="syncBtn" 
       aria-label={m.team_menu_sync_changes()}>
        <i class="bi bi-cloud-upload" aria-hidden="true"></i>
    </a>
</li>

<style lang="css">
.text-warning>i {
    animation: fade 1s linear infinite;
}

@keyframes fade {  
  50% { opacity: 0.2; }
}
</style>